// extracted by mini-css-extract-plugin
module.exports = {"carNumberLoadStatus":"CarNumber_carNumberLoadStatus__gV1f2","loadStatusText":"CarNumber_loadStatusText__VwewT"};